import React from 'react';
import _EasyNeedOfferContainer from './_EasyNeedOfferContainer.scss';
import EasyNeedOffer from 'components/partials/easy-need-offer';
import {Demands} from 'api';
import {Link} from 'react-router-dom';

class EasyNeedOfferContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 3,
      order: 'id DESC'
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isApprove: true
        }
      }
    };
    Demands.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    return (
      <section className="easy-need-offer-container">
        <div className='easy-need-offer-wrap'>
          <div className='content-justify'>
            <h2 className='easy-need-offer-title'>Kết nối nhanh</h2>
            <Link className='view-more-link' to='/demands'>Xem tất cả</Link>
          </div>
          <div className='wrap-item'>
            {
              this.state.data.map((item, i) => {
                return (
                  <EasyNeedOffer {...item} key={i}/>
                );
              })
            }
          </div>
        </div>
      </section>
    );
  }
}

export default EasyNeedOfferContainer;



// WEBPACK FOOTER //
// ./components/home/sub-view/EasyNeedOfferContainer.jsx